import React, { useState } from 'react';
import './AboutUs.css';
import pic1 from "../assets/s2.webp";
import pic2 from "../assets/s3.webp";
import pic3 from "../assets/s1.webp";
import presidentPic from "../assets/jaideepbihani.webp";
import principalPic from "../assets/IMG_4300.webp";
import vicepresident from "../assets/Himanshu B.jpg";

const AboutUs = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    { src: pic1, alt: 'Gallery 1' },
    { src: pic2, alt: 'Gallery 2' },
    { src: pic3, alt: 'Gallery 3' }
  ];

  const leaders = [
    {
      id: 1,
      name: 'SHRI JAIDEEP BIHANI',
      title: 'President',
      image: presidentPic,
      quote: 'Education is not the learning of facts But the training of mind to think',
      shortText: 'The first decade of the millennium is expected to be a very crucial phase for humanity where the whole world would face the accumulated adverse consequence of the blind pursuit for materialistic power, pelf and possessions. The advancement of Science & Technology is being used for the annihilation of life on the earth.',
      fullText: 'The first decade of the millennium is expected to be a very crucial phase for humanity where the whole world would face the accumulated adverse consequence of the blind pursuit for materialistic power, pelf and possessions. The advancement of Science & Technology is being used for the annihilation of life on the earth. Education develops the body and the soul of the pupils with all those beauties and perfections which one is capable of. With this objective, the tree of SETH GIRDHARI LAL BIHANI SANATAN DHARAM SHIKSHA TRUST Sri Ganganagar was planted in the year 1951.'
    },
    {
      id: 2,
      name: 'MR. HIMANSHU BIHANI',
      title: 'Vice President',
      image: vicepresident,
      quote: 'The beautiful thing about learning is that no one can take it away from you',
      shortText: 'Education is the most powerful tool for shaping minds, building character, and creating a progressive society. At Bihani Children\'s Academy, we strongly believe that education is not limited to academic achievement alone, but is a lifelong journey of learning, self-discovery, and personal growth.',
      fullText: 'Education is the most powerful tool for shaping minds, building character, and creating a progressive society. At Bihani Children\'s Academy, we strongly believe that education is not limited to academic achievement alone, but is a lifelong journey of learning, self-discovery, and personal growth. Our mission is to provide an environment where students are encouraged to think independently, act responsibly, and grow confidently.'
    },
    {
      id: 3,
      name: 'MRS. NALINI DHINGRA',
      title: 'Principal',
      image: principalPic,
      quote: 'Education awakens the power beauty that lie within us.',
      shortText: 'Education does not only man academic excellence. It rather is a harmonious and synchronized combination of hand (skills like various arts), head (Intellectual Power) and heart (Value System).',
      fullText: 'Education awakens the power beauty that lie within us. Education does not only man academic excellence. It rather is a harmonious and synchronized combination of hand (skills like various arts), head (Intellectual Power) and heart (Value System). In the present era of digitalized world, it is the biggest challenge before educators and parents, to nurture the young minds with the indelible impressions of a holistic education. Therefore, we come up with a vision to foster different facets of a student.'
    }
  ];

  const councilMembers = [
    { name: 'Sh. Jaideep Bihani', role: '(President)' },
    { name: 'Sh. Neeraj Bihani', role: '(Vice President)' },
    { name: 'Mrs. Nalini Dhingra', role: '(Principal & Secretary)' },
    { name: 'Sh. Himanshu Bihani', role: '(Jt. Secretary)' },
    { name: 'Sh. Omprakash Bihani', role: '(Member)' },
    { name: 'Sh. Madhu Sudan Bihani', role: '(Member)' },
    { name: 'Sh. Sharad Kumar Bihani', role: '(Member)' },
    { name: 'Sh. Vimal Bihani', role: '(Member)' },
    { name: 'Sh. Satish Chander Jain', role: '(Member)' },
    { name: 'Smt. Ranjana Bihani', role: '(Member)' },
    { name: 'Smt. Savita Bihani', role: '(Member)' },
    { name: 'Smt. Monika Bihani', role: '(Member)' },
    { name: 'Smt. Shailja Pasricha', role: '(Member)' },
    { name: 'Sh. Sohan Lal Principal', role: '(BSF)' },
    { name: 'Sh. Krishan Kumar Principal', role: '(Center School Sadhuwali)' },
    { name: 'Smt. Nalini Dhingra Member', role: '(School Teacher)' },
    { name: 'Smt. Minakshi Jaitly Member', role: '(School Teacher)' },
    { name: 'Sh. Varun Maheshwari Member', role: '(Lecturer Other Dept)' },
    { name: 'Smt. Mandeep Bhatia Member', role: '(Lecturer Other Dept)' },
    { name: 'Smt. Anjana Sihag Member', role: '(Guardian)' },
    { name: 'Smt. Poonam Sharma Member', role: '(Guardian)' }
  ];

  const handleReadMore = (leaderId) => {
    const routes = {
      1: '/president',
      2: '/vicepresident',
      3: '/principal'
    };
    window.location.href = routes[leaderId];
  };

  return (
    <div className="bca-about-container">
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>ABOUT-US</h1>
        </div>
      </section>

      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>About</li>
          </ul>
        </div>
      </section>

      <div className="bca-leadership-section">
        <div className="bca-leadership-container">
          {leaders.map((leader) => (
            <div key={leader.id} className="bca-leader-card">
              <div className="bca-leader-image">
                <img src={leader.image} alt={leader.name} />
              </div>
              
              <div className="bca-leader-content">
                <h2 className="bca-leader-name">{leader.name}</h2>
                <p className="bca-leader-title">{leader.title}</p>
                
                <div className="bca-leader-quote">
                  "{leader.quote}"
                </div>
                
                <p className="bca-leader-text">
                  {leader.shortText}
                </p>
                
                <button 
                  className="bca-read-more-btn"
                  onClick={() => handleReadMore(leader.id)}
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bca-about-content">
        <div className="bca-about-text">
          <p>
            Education develops the body and the soul of the pupils with all those beauties and perfections which one is capable of. With this objective, the tree of SETH GIRDHARI LAL BIHANI SANATAN DHARAM SHIKSHA TRUST Sri Ganganagar was planted in the year 1951 by Seth Girdhari Lal Ji Bihani who got religion, social service and firm determination in heredity from his father Seth Ganggal Das Ji Bihani.
          </p>

          <p>
            Bihani Children's Academy is the brain child of Bhamasiah Seth Sushil Kumar Ji Bihani a great philosopher and philanthropist who nurtured the sapling of education catering to the needs of community. The academy, a dream project of great visionary was established on 2nd July 1989, the foundation stone of which was laid by Haralal Dexpura. After the sudden demise of Seth Sushil Kumar Ji Bihani, the responsibility was shouldered by the President of Bihani Education Trust Shri Jaideep Ji Bihani. BCA, an English medium school affiliated to C.B.S.E. board provides quality education in science, arts and commerce streams.
          </p>

          <p>
            Pre-Nursery wing of B.C.A. was set up with pool and Mini Zoo in 1997. It provides hi-tech environment with multi sensory approach under the supervision of skilled educators. The best equipments, teaching gadgets, enticing toys, well trained and care taking faculty create opportunities for physical, mental and emotional growth of little toddlers. Indoor games and outdoor playground with swing see-saw, slides, etc help children to learn sharing by caring. Multiple activities, celebrating festivals, dining together make teachings-learning process informative and interesting.
          </p>

          <p>
            Separate Kindergarten primary wing and junior wing equipped with projectors and smart classes provide virtual education, sufficient seating facility, airy and ventilated rooms. Air conditioning provisions for summer season, mid-day meal facility with separate playground make it attractive. Well trained and experienced mentors pay personal attention for overall development of child. Individual progress is the sole aim on to mold ideal citizens imbibing moral and values. Subjects such as Maths, Hindi, English and Social Sciences are taught with activities based learning.
          </p>

          <p>
            Education develops self analyzing skills that grooms potential and intellect with energy. Students of senior wing are trained to inculcate competitive attitude and self study spirit to evaluate themselves for which Olympiads are organized regularly.
          </p>

          <p>
            Senior secondary wing is undoubtedly comparable to the best amongst progressive schools. Academy ensures to council for career, think creatively, act rationally and communicate effectively. The integrated perspective of modern education with practical implication of theoretical knowledge follow the concept of working themselves in different labs. Music and indoor games room encourage the pupils to question, to explore, to analyze for adopting scientific approach with moral traditional values. Team work during presentation in seminars, group discussions, interschool competitions, quizzes, contests, declamations, science and art exhibitions glorify pupil's personality. Active participation in social and productive rallies improves their literary, social and academic excellence.
          </p>

          <p>
            The facilities and infrastructure for games, sports and cultural activities are of immense help to those willing to make career in any field. Bihani Children's Academy is indeed fortunate to have a splendid Bhamasiah Seth Sushil Kumar Bihani indoor stadium and auditorium for all co-curricular activities which is spacious and airy with seating capacity of 1000 people. It is best in the region with latest technology for the light, sound and projection system.
          </p>

          <p>
            B.C.A. also facilitates cricket lover with S.K.Bihani Cricket Academy with well trained and expert professional which provides innovative cricket coaching. Students get opportunities to play at district, state and national level. It has flood lights facilities with automated rollers, grass cutter, updated sports and provision for stump-vision cameras.
          </p>

          <p>
            Participation in games and sports is motivated through regular classes for outdoor games, inter-house competitions, friendly matches of hand ball, badminton, kabaddi etc. School is equipped with wooden badminton court, judo and karate court. It has provisions for table tennis, volley ball and football etc. The school provides regular yoga practice which is inseparable part of school curriculum to develop an aesthetic sense. Laboratories, computer rooms and spacious library enriched with encyclopedias, dictionaries, thesaurus and novels help to improve focus and concentration power of pupils.
          </p>

          <p>
            BCA, a centrally located institution with lush green playgrounds is well known for its achievements in academics, sports and interschool competitions. Students are always inspired by experienced and dedicated faculty members to participate with mounting efforts.
          </p>

          <div className="bca-about-quote">
            "An Investment in knowledge pays the best interest".
          </div>

          <div className="bca-about-gallery">
            <div className="bca-gallery-grid">
              {galleryImages.map((image, index) => (
                <div 
                  key={index}
                  className="bca-gallery-item"
                  onClick={() => {
                    setSelectedImage(image);
                    setLightboxOpen(true);
                  }}
                >
                  <img src={image.src} alt={image.alt} />
                </div>
              ))}
            </div>
          </div>

          {lightboxOpen && (
            <div className="bca-lightbox" onClick={() => setLightboxOpen(false)}>
              <div className="bca-lightbox-content" onClick={(e) => e.stopPropagation()}>
                <button className="bca-lightbox-close" onClick={() => setLightboxOpen(false)}>×</button>
                <img src={selectedImage.src} alt={selectedImage.alt} />
              </div>
            </div>
          )}
        </div>

        <div className="bca-council-box">
          <h2 className="bca-council-title">Management Council</h2>
          <ul className="bca-council-members">
            {councilMembers.map((member, index) => (
              <li key={index} className="bca-council-member">
                <strong>{member.name}</strong> {member.role && <span>{member.role}</span>}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;